// Note: only #imports is a valid source here, otherwise the app will never finish loading!!!
import { defineAppConfig } from '#imports'
import type { AppCountryConfig } from '~/index'

export default defineAppConfig({
  countryConfig: {
    at: {
      envOverwrites: {
        prod: {
          disabled: true,
        },
        staging: {
          internalApiUrl: 'https://shop-staging.heiland.com/at',
        },
      },
      registrationClinicChains: ['VetFamily'],
      internalApiUrl: 'https://shop.heiland.com/at',
      mainDomain: 'heiland.com',
      localName: 'Österreich',
      appBarLogo: '/logos/heiland_logo_light.svg',
      registrationPageLogo: '/logos/heiland_logo_red.svg',
      ogImage: 'https://shop.heiland.com/logos/heiland-pwa-logo.png',
      favicon: '/icons/favicon-heiland.ico',
      titleTranslationKey: 'layouts.titleHeiland',
      homeUrl: 'https://home.heiland.com',
      helpUrl: 'https://help.heiland.com/de-form/',
      searchLanguage: 'de',
      martailerLanguage: 'de',
      gtmLanguage: 'en',
      gtmId: 'GTM-K6T8LJSN',
      googleAdsenseId: 'ca-pub-7184100102884576',
      productFruitsCode: 'YbfZHMisYDNhU0SJ',
      supportEmail: 'mail@heiland.com',
      feature: {
        displayVetNarcoticsNumber: true,
        displayPharmacyReference: true,
      },
      popularProductCategories: [
        { treePath: ['Pharma', 'Antiparasitika'] },
        { treePath: ['Pharma', 'Antiphlogistika'] },
        { treePath: ['Pharma', 'Impfstoffe und Sera'] },
        { treePath: ['Pharma', 'Haut, Haare, Horngebilde'] },
        { treePath: ['Futter'] },
        { treePath: ['Praxisbedarf', 'Hygiene'] },
        { treePath: ['Praxisbedarf', 'Behandlung', 'Spritzen & Kanülen', 'Kanülen'] },
        { treePath: ['Praxisbedarf', 'Behandlung', 'Spritzen & Kanülen', 'Spritzen'] },
      ],
      marketingCampaigns: {
      },
    },
    de: {
      envOverwrites: {
        staging: {
          gtmId: 'GTM-M2G2SF7B',
          internalApiUrl: 'https://shop-staging.heiland.com/de',
          hubspotBusinessUnitId: '16151721',
          registrationClinicChains: [
            'ActiVet', 'Altano', 'AniCura', 'Cadomo', 'Doc4pets', 'Evidensia',
            'Felmo', 'filu', 'Gft', 'Medivet', 'Nesto', 'One Vet', 'Rex',
            'Smartemis', 'TeamVet', 'test', 'Tpp', 'Veternicum', 'VetFamily',
            'VetGruppen', 'Vetpartners', 'Vuk', 'Wolf&Tiger',
          ],
          martailerBannerSlots: {
            generalCategoryBanner: 'a7cceb54-697e-4290-bdfc-2cd02bf0042e',
            searchTopBanner: 'ddc9c2e8-27cc-44e2-8baa-5d09a1f0c770',
            welcomeTopBanner: 'fe8b37f2-63da-4339-b1b9-cb44d2cab80a',
            generalGpoBanner: '0b6aefdb-f2cf-40f1-927b-c5833b4a296a',
            generalSupplierBanner: '69332363-5c5f-4011-8bfb-c7b68d5633ac',
          },
          feature: {
            displayVetNarcoticsNumber: true,
            displayPharmacyReference: true,
            displayVoucherCode: true,
            useMartailerAds: true,
            useMartailerSponsoredProducts: true,
            displayPharmacyBanner: true,
            displayPharmacyRegistrationCertificate: true,
          },
          welcomeGpoCarouselClinicChainHandles: ['vetfamily'],
          discountFlagCampaigns: {
            ImsAssortment: { supplierHandle: 'ims_euro', discountPercent: 10, startDate: '2026-06-01', endDate: '2026-08-01' },
          },
        },
      },
      registrationClinicChains: [
        'ActiVet', 'Altano', 'AniCura', 'Cadomo', 'Doc4pets', 'Evidensia',
        'Felmo', 'filu', 'Gft', 'Medivet', 'Nesto', 'One Vet', 'Rex',
        'Smartemis', 'TeamVet', 'Tpp', 'Veternicum', 'VetFamily',
        'VetGruppen', 'Vetpartners', 'Vuk', 'Wolf&Tiger',
      ],
      internalApiUrl: 'https://shop.heiland.com/de',
      mainDomain: 'heiland.com',
      localName: 'Deutschland',
      appBarLogo: '/logos/heiland_logo_light.svg',
      registrationPageLogo: '/logos/heiland_logo_red.svg',
      ogImage: 'https://shop.heiland.com/logos/heiland-pwa-logo.png',
      favicon: '/icons/favicon-heiland.ico',
      titleTranslationKey: 'layouts.titleHeiland',
      homeUrl: 'https://home.heiland.com',
      helpUrl: 'https://help.heiland.com/de-form/',
      searchLanguage: 'de',
      martailerLanguage: 'de',
      gtmLanguage: 'en',
      gtmId: 'GTM-W86XPFMM',
      googleAdsenseId: 'ca-pub-7184100102884576',
      productFruitsCode: 'YbfZHMisYDNhU0SJ',
      hubspotBusinessUnitId: '16151721',
      supportEmail: 'mail@heiland.com',
      feature: {
        displayVetNarcoticsNumber: true,
        displayPharmacyReference: true,
        displayVoucherCode: true,
        useMartailerAds: true,
        useMartailerSponsoredProducts: true,
        displayPharmacyBanner: true,
        displayPharmacyRegistrationCertificate: true,
      },
      martailerBannerSlots: {
        generalCategoryBanner: '69186587-601f-4404-82fe-69e4c56053de',
        searchTopBanner: '1e3fc405-710f-40d4-9a1f-29a3cd4b0fd1',
        welcomeTopBanner: 'ec4a71ab-7491-4a8d-aace-8a412970cbe3',
        generalGpoBanner: '62127010-b3b8-40b7-a95f-25ff891bc25b',
        generalSupplierBanner: 'ba9d675d-b404-49aa-8599-8c26724603b8',
      },
      popularProductCategories: [
        { treePath: ['Pharma', 'Antiparasitics'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Anti-inflammatory'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Vaccines and Sera'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Skin, Hair, Horny Structures'], pathLocale: 'en' },
        { treePath: ['Pet Food'], pathLocale: 'en' },
        { treePath: ['Consumables', 'Hygiene'], pathLocale: 'en' },
        { treePath: ['Consumables', 'Treatment', 'Syringes & Cannulas', 'Cannulas'], pathLocale: 'en' },
        { treePath: ['Consumables', 'Treatment', 'Syringes & Cannulas', 'Syringes'], pathLocale: 'en' },
      ],
      marketingCampaigns: {
        Tessie: { startDate: '2024-10-02', supplierHandle: 'tvm' },
        IMS: { startDate: '2025-05-27', supplierHandle: 'ims_euro' },
        Heel: { startDate: '2026-03-01', endDate: '2026-06-30', supplierHandle: 'heel' },
        Domespharma2: { startDate: '2026-04-01', endDate: '2026-05-31', name: 'Dômes Pharma - Remend', supplierHandle: 'tvm' },
        Domespharma3: { startDate: '2026-07-01', endDate: '2026-07-31', name: 'Dômes Pharma - Tessie', supplierHandle: 'tvm' },
      },
    },
    fr: {
      envOverwrites: {
        staging: {
          disabled: true,
          gtmId: 'GTM-NCHZZJD',
        },
        prod: {
          discountFlagCampaigns: {
            ImsAssortment: { supplierHandle: 'ims_euro', discountPercent: 10, startDate: '2026-06-01', endDate: '2026-07-31' },
          },
        },
      },
      registrationClinicChains: [
        'AlpiVet', 'Anicura', 'Aniserv 76', 'Argos', 'Confluences.Vet',
        'Douaisis', 'Edelvet', 'Emeuraude', 'Evidensia', 'Excellvet 49-44-79',
        'Fevec', 'Idvet', 'Isovet', 'La Yole 79-86', 'Les Remparts',
        'My veto', 'Qovetia', 'Qovetia VF', 'Reseau Averoes', 'ReSoluVet',
        'SAS Blue', 'SAS Vetogroupe', 'SCM 142', 'Sevetys',
        'Symbiovéto 50', 'Symbiovéto 50 + Vetmanche + Vetoalliance',
        'SYNERVET 35', 'Univet', 'Un Veto a la Campagne', 'Vetanimax',
        'VetBoost', 'Veterinaires Passion', 'VetFamily Confort',
        'VetFamily Performance', 'VetFamily Premium', 'Vet Harmonie',
        'Vet Horizon (orne)', 'Vetmanche', 'Vetoalliance', 'Veto Alliance 76',
        'Vetoccitan', 'Vetosol', 'Vetpartners', 'Vets4Vets', 'Vet Set',
      ],
      internalApiUrl: 'https://shop.vetmazing.com/fr',
      mainDomain: 'vetmazing.com',
      localName: 'France',
      appBarLogo: '/logos/vetmazing_lightred.svg',
      registrationPageLogo: '/logos/vetmazing_logo_red.svg',
      ogImage: 'https://shop.vetmazing.com/logos/vetmazing-pwa-logo.png',
      favicon: '/icons/favicon-vetmazing.ico',
      titleTranslationKey: 'layouts.titleVetmazing',
      homeUrl: 'https://home.vetmazing.com',
      helpUrl: 'https://help.vetmazing.com/fr',
      searchLanguage: 'fr',
      martailerLanguage: 'fr',
      gtmLanguage: 'en',
      gtmId: 'GTM-P85HCRSX',
      googleAdsenseId: 'ca-pub-7184100102884576',
      productFruitsCode: 'qgrYcgHIzObpziZG',
      hubspotBusinessUnitId: '18869077',
      supportEmail: 'mail@vetmazing.com',
      feature: {
        displayOfficialClinicNumber: true,
        displayVetDiplomaNumber: true,
        displayPharmacyBanner: false,
        displayPharmacyRegistrationCertificate: false,
        useMartailerAds: true,
        useMartailerSponsoredProducts: true,
      },
      martailerBannerSlots: {
        generalCategoryBanner: '69186587-601f-4404-82fe-69e4c56053de',
        searchTopBanner: '1e3fc405-710f-40d4-9a1f-29a3cd4b0fd1',
        welcomeTopBanner: 'ec4a71ab-7491-4a8d-aace-8a412970cbe3',
        generalGpoBanner: '62127010-b3b8-40b7-a95f-25ff891bc25b',
        generalSupplierBanner: 'ba9d675d-b404-49aa-8599-8c26724603b8',
      },
      popularProductCategories: [
        { treePath: ['Pharma', 'Antiparasitics'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Anti-inflammatory'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Cardiovascular'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Respiratory Tract'], pathLocale: 'en' },
        { treePath: ['Pharma', 'Hormones'], pathLocale: 'en' },
        { treePath: ['Pet Food', 'Supplementary Feed'], pathLocale: 'en' },
      ],
      marketingCampaigns: {
      },
      welcomeGpoCarouselClinicChainHandles: ['vetfamily_premium'],
    },
  } satisfies AppCountryConfig,
})
